import { newsList, topics } from "@/mocks/news";
import type { NewsItem } from "@/mocks/news";

export const categories = [
  {
    slug: "society",
    name: "社会爆料",
    desc: "城市生活、民生政策与公共事件的现场追踪，第一时间梳理事发经过与官方回应。",
    en: "SOCIETY",
  },
  {
    slug: "entertainment",
    name: "娱乐爆料",
    desc: "明星动态、影视综艺与行业合约的最新消息，只看公开信息，不做无依据推测。",
    en: "ENTERTAINMENT",
  },
];

export function getCategory(slug?: string) {
  return categories.find((item) => item.slug === slug);
}

export function getNewsById(id?: string): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}

export function getTopicById(id?: string) {
  return topics.find((item) => item.id === id);
}

export function getNewsByCategory(slug: string): NewsItem[] {
  return newsList.filter((item) => item.categorySlug === slug);
}

export function getNewsByTopic(topicId: string): NewsItem[] {
  return newsList.filter((item) => item.topicId === topicId);
}

export function sortedByTime(list: NewsItem[]): NewsItem[] {
  return [...list].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
}

export function sortedByHeat(list: NewsItem[]): NewsItem[] {
  return [...list].sort((a, b) => b.heat - a.heat);
}

export function filterByRange(list: NewsItem[], range: string): NewsItem[] {
  const now = new Date("2026-10-17T12:00:00+08:00").getTime();
  const hoursMap: Record<string, number> = { "24h": 24, "7d": 168, "30d": 720 };
  const hours = hoursMap[range];
  if (!hours) return list;
  return list.filter((item) => now - new Date(item.publishedAt).getTime() <= hours * 3600 * 1000);
}

export function searchNews(keyword: string): NewsItem[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return sortedByTime(
    newsList.filter((item) => {
      const haystack = [item.title, item.summary, item.content.join(""), item.tags.join(" ")]
        .join(" ")
        .toLowerCase();
      return haystack.includes(key);
    }),
  );
}

export function relatedNews(item: NewsItem, count = 4): NewsItem[] {
  return sortedByHeat(
    newsList.filter((it) => it.id !== item.id && it.categorySlug === item.categorySlug),
  ).slice(0, count);
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  const hh = `${d.getHours()}`.padStart(2, "0");
  const mm = `${d.getMinutes()}`.padStart(2, "0");
  return `${formatDate(iso)} ${hh}:${mm}`;
}

export function relativeTime(iso: string): string {
  const now = new Date("2026-10-17T12:00:00+08:00").getTime();
  const diff = Math.max(now - new Date(iso).getTime(), 0);
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `${Math.max(minutes, 1)} 分钟前`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} 小时前`;
  const days = Math.floor(hours / 24);
  if (days < 8) return `${days} 天前`;
  return formatDate(iso);
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export function paginate<T>(list: T[], page: number, size: number) {
  const totalPages = Math.max(Math.ceil(list.length / size), 1);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  return {
    items: list.slice((safePage - 1) * size, safePage * size),
    totalPages,
    page: safePage,
    total: list.length,
  };
}